import styled, { css } from 'styled-components'
import { Section as BaseSection } from '../common/styles'
import { desktopBreakpoint } from 'react-components'

export const Section = styled(BaseSection)(
    ({ theme }) => css`
        @media only screen and (max-width: ${desktopBreakpoint.min}px) {
            padding: ${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.xSmall};
        }
    `,
)

export const SeoList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`

export const SeoItem = styled.div(
    ({ theme }) => `
    margin-bottom: 1.5rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid ${theme.colors.tfwBlackOpacity10};
`,
)

export const Question = styled.h2(
    ({ theme }) => `
    font-family: ${theme.typography.font.family.inter};
    font-size: ${theme.typography.font.size.large};
    font-weight: 600;
    color: ${theme.colors.tfwBlack87};
    margin: 0 0 0.5rem 0;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        font-size: ${theme.typography.font.size.large};
    }
`,
)
